import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export type IRepairCode = dataService.IRepairCode;

export function genComponentAndControllerGenerator(storeId: string) {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => dataService.useQuery(storeId),
    fnGetObjectLabel: object => object.repairCode
  });
}
